import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-615e0776"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "boxes" };
const _hoisted_2 = ["id", "checked", "disabled"];
const _hoisted_3 = ["for"];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isInitCheck: { type: Boolean },
        label: null,
        id: null,
        isDisabled: { type: Boolean }
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        const checked = ref(props.isInitCheck);
        const changed = () => {
            checked.value = !checked.value;
            emit('change', checked.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("input", {
                    type: "checkbox",
                    id: `box-${props.id}`,
                    checked: checked.value,
                    onChange: changed,
                    disabled: __props.isDisabled
                }, null, 40, _hoisted_2),
                _createElementVNode("label", {
                    for: `box-${props.id}`
                }, _toDisplayString(props.label), 9, _hoisted_3)
            ]));
        };
    }
});
